/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_CatInputs */

const en_val_cat = /** @type {(inputs: Val_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cat`)
};

const es_val_cat = /** @type {(inputs: Val_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gato`)
};

const fr_val_cat = /** @type {(inputs: Val_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat`)
};

const de_val_cat = /** @type {(inputs: Val_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katze`)
};

const ja_val_cat = /** @type {(inputs: Val_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`猫`)
};

const zh_val_cat = /** @type {(inputs: Val_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`猫`)
};

const ar_val_cat = /** @type {(inputs: Val_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قطة`)
};

const id_val_cat = /** @type {(inputs: Val_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kucing`)
};

const it_val_cat = /** @type {(inputs: Val_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gatto`)
};

const ru_val_cat = /** @type {(inputs: Val_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кошка`)
};

const pt_val_cat = /** @type {(inputs: Val_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gato`)
};

const ko_val_cat = /** @type {(inputs: Val_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`고양이`)
};

/**
* | output |
* | --- |
* | "Cat" |
*
* @param {Val_CatInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_cat = /** @type {((inputs?: Val_CatInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_CatInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_cat(inputs)
	if (locale === "es") return es_val_cat(inputs)
	if (locale === "fr") return fr_val_cat(inputs)
	if (locale === "de") return de_val_cat(inputs)
	if (locale === "ja") return ja_val_cat(inputs)
	if (locale === "zh") return zh_val_cat(inputs)
	if (locale === "ar") return ar_val_cat(inputs)
	if (locale === "id") return id_val_cat(inputs)
	if (locale === "it") return it_val_cat(inputs)
	if (locale === "ru") return ru_val_cat(inputs)
	if (locale === "pt") return pt_val_cat(inputs)
	return ko_val_cat(inputs)
});